/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  CreateSasDownloadRequestBody,
  CreateSasDownloadResponse,
  CreateSasUploadRequestBody,
  CreateSasUploadResponse,
  GetSasUuidResponse
} from '../model';

import getSasUuidMutator from '../../../mutators/datastore-instance';
import postUploadSasMutator from '../../../mutators/datastore-instance';
import postDownloadSasMutator from '../../../mutators/datastore-instance';



  /**
 * アップロード親フォルダであるUUIDを発行する
 * @summary UUID発行用API
 */
export const getSasUuid = (

 ) => {
      return getSasUuidMutator<GetSasUuidResponse>(
      {url: `/sas/uuid`, method: 'GET'
    },
      );
    }
  /**
 * ファイルアップロード用のSASを発行する
 * @summary ファイルアップロード用SAS発行
 */
export const postUploadSas = (
    createSasUploadRequestBody?: CreateSasUploadRequestBody,
 ) => {
      return postUploadSasMutator<CreateSasUploadResponse>(
      {url: `/sas/upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSasUploadRequestBody
    },
      );
    }
  /**
 * ファイルダウンロード用のSASを発行する
 * @summary ダウンロード用SAS発行
 */
export const postDownloadSas = (
    createSasDownloadRequestBody?: CreateSasDownloadRequestBody,
 ) => {
      return postDownloadSasMutator<CreateSasDownloadResponse>(
      {url: `/sas/download`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSasDownloadRequestBody
    },
      );
    }
  export type GetSasUuidResult = NonNullable<Awaited<ReturnType<typeof getSasUuid>>>
export type PostUploadSasResult = NonNullable<Awaited<ReturnType<typeof postUploadSas>>>
export type PostDownloadSasResult = NonNullable<Awaited<ReturnType<typeof postDownloadSas>>>
